import { format, parseISO } from 'date-fns'
import tr from 'date-fns/locale/tr'
import en from 'date-fns/locale/en-US'

export const parseISODate = (date: string, locale: string) => {
  return format(parseISO(date), 'dd MMMM yyyy', {
    locale: locale === 'tr' ? tr : en,
  })
}
